import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { persistor } from "../../../AsianExchangeSrc/redux/store";
import {
  revertUser,
  updateAvailableBalance,
  updateUserCasinoBalance,
} from "../../../AsianExchangeSrc/redux/slices/userSlice";
import { revertAccount } from "../../../AsianExchangeSrc/redux/slices/accountSlice";
import { ReCallCasinoBalance } from "../../../AsianExchangeSrc/api";
import { toast } from "react-toastify";
import { useState } from "react";
import { PiCurrencyInrFill } from "react-icons/pi";
import { isSignupUser } from "../../../AsianExchangeSrc/utils/helper/commonSelectors";
import DepositWithdraw from "../../components/Deposit&Withdraw/Deposit&Withdraw";
import { FaUserCircle } from "react-icons/fa";
import { FaSignOutAlt } from "react-icons/fa";

const Account = () => {
  const dispatch = useDispatch();
  const userData = useSelector((state) => state?.user?.userData);
  const [isLoading, setIsLoading] = useState(false);
  const signupUser = useSelector(isSignupUser());
  const IsLoggedIn = useSelector((state) => state.user.isLoggedIn);
  const menuItems = [
    { name: "My Profile", href: "/myprofile" },
    { name: "Multi Markets", href: "/multimarket" },
    { name: "Rolling Commission", href: "/rolling-commission" },
    { name: "Account Statement", href: "/account-statement" },
    { name: "Bets History", href: "/bets-history" },
    { name: "Profit & Loss", href: "/profit-loss" },
    { name: "Password History", href: "/password-history" },
    { name: "Activity Log", href: "/activity-log" },
    { name: "Casino Balance", href: "#" },
  ];

  const handleMenuClick = (item) => {
    console.log(`Clicked on ${item.name}`);
  };

  const handleLogout = (event) => {
    event.preventDefault();
    dispatch(revertUser());
    dispatch(revertAccount());
    localStorage.clear();
    persistor.purge();
    setTimeout(() => {
      window.location.href = "/";
    }, 300);
  };

  const handlereCall = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const response = await ReCallCasinoBalance({
        CasinoBalance: userData?.casinoBalance,
      });
      
      dispatch(updateAvailableBalance(response.data.user.availableBalance));
      dispatch(updateUserCasinoBalance(response.data.user.casinoBalance));
      toast.success(response.data.message);
    } catch (error) {
      const errorMessage = error.response?.data?.message || "Error occurred";
      toast.error(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <div className="bg-[#EDEDED]">
        {IsLoggedIn && signupUser && <DepositWithdraw />}
        {/* Header */}
        <div className="bg-[linear-gradient(-180deg,_#2E4B5E_0%,_#243A48_82%)] px-2 py-1.5 flex items-center gap-3">
          <FaUserCircle size={19} color="white" />
          <span className="text-white text-[15px]">
            {userData?.userName || "Unknown User"}
          </span>
        </div>

        {/* Menu Items */}
        <div className="bg-light-bg dark:bg-dark-bg">
          {menuItems.map((item, index) =>
            item.name === "Casino Balance" ? (
              <Link
                key={index}
                to={item.href}
                onClick={() => handleMenuClick(item)}
                className="flex items-center justify-between px-3 py-2 border-b border-gray-300 cursor-pointer hover:bg-gray-200 transition-colors"
              >
                <span className="text-[#2789ce] text-[14px] font-[700]">
                  {item.name}
                </span>

                {userData?.casinoBalance ? (
                  <div className="flex items-center justify-between rounded-xl cursor-pointer hover:bg-gray-50 transition-all duration-300 ease-in-out">
                    <button
                      onClick={handlereCall}
                      disabled={isLoading}
                      className="flex items-center gap-2.5 px-4 py-1.5 bg-gradient-to-r from-[#2b6cb0] to-[#4299e1] text-white font-medium rounded-lg shadow-lg hover:from-[#1e4976] hover:to-[#3182ce] hover:scale-105 transition-all duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-[#2b6cb0] focus:ring-opacity-60 disabled:opacity-50 disabled:cursor-not-allowed"
                      aria-label={`Recall casino balance${
                        userData?.casinoBalance
                          ? ` of ${userData.casinoBalance.toFixed(0)}`
                          : ""
                      }`}
                    >
                      <PiCurrencyInrFill className="w-4 h-4 md:w-5 md:h-5" />
                      <span className="text-xs md:text-sm">Recall</span>
                      <span className="bg-light-bg dark:bg-dark-bg text-[#2b6cb0] px-2.5 py-0.5 rounded-full text-[10px] md:text-xs font-semibold shadow-inner">
                        {isLoading ? (
                          <svg
                            className="animate-spin h-4 w-4 text-[#2b6cb0]"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                          >
                            <circle
                              className="opacity-25"
                              cx="12"
                              cy="12"
                              r="10"
                              stroke="currentColor"
                              strokeWidth="4"
                            ></circle>
                            <path
                              className="opacity-75"
                              fill="currentColor"
                              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                            ></path>
                          </svg>
                        ) : (
                          userData?.casinoBalance?.toFixed(0) || "0"
                        )}
                      </span>
                    </button>
                  </div>
                ) : (
                  <></>
                )}
              </Link>
            ) : (
              <Link
                key={index}
                to={item.href}
                onClick={() => handleMenuClick(item)}
                className="flex items-center justify-between px-3 py-2 border-b border-gray-300 cursor-pointer hover:bg-gray-200 transition-colors"
              >
                <span className="text-[#2789ce] text-[14px] font-[700]">
                  {item.name}
                </span>
                <div className="w-7 h-7 border-2 border-gray-950 dark:border-white rounded-sm flex items-center justify-center">
                  <svg
                    className="w-4 h-4 text-gray-950 dark:text-white"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M9 5l7 7-7 7"
                    />
                  </svg>
                </div>
              </Link>
            )
          )}
        </div>
      </div>

      <div className="bg-gray-100 mt-5">
        <button
          style={{
            background: "linear-gradient(-180deg, #e93522 0%, #be2414 100%)",
          }}
          onClick={handleLogout}
          className="w-full text-white font-bold border border-[#8a0011] py-2.5 px-4 flex items-center justify-center space-x-3 transition-colors"
        >
          <span className="text-[15px]">LOGOUT</span>
          <FaSignOutAlt />
        </button>
      </div>
    </>
  );
};

export default Account;
